(() => {
  const selector = '[data-banner-video-autoplay]';

  class BannerVideo {
    constructor(root) {
      this.root = root;
      this.videos = [...root.querySelectorAll('video')];
      this.mediaQuery = window.matchMedia('(min-width: 750px)');
      this.events = new AbortController();
      const bounds = root.getBoundingClientRect();
      this.nearViewport = bounds.width > 0 && bounds.bottom > -200
        && bounds.top < window.innerHeight + 200;
      const sync = () => this.sync();
      const options = { signal: this.events.signal };
      this.mediaQuery.addEventListener('change', sync, options);
      document.addEventListener('visibilitychange', sync, options);
      this.observer = new IntersectionObserver(([entry]) => {
        this.nearViewport = entry.isIntersecting;
        this.sync();
      }, { rootMargin: '200px 0px' });
      this.observer.observe(root);
      document.addEventListener('shopify:section:unload', (event) => {
        if (!event.target.contains(root)) return;
        this.events.abort();
        this.observer.disconnect();
        this.videos.forEach(video => video.pause());
      }, options);
      this.sync();
    }

    sync() {
      this.videos.forEach(video => {
        const desktop = !!video.closest('.cycology-banner-3__video--desktop');
        const play = this.root.dataset.bannerVideoAutoplay === 'true'
          && this.nearViewport && !document.hidden
          && desktop === this.mediaQuery.matches && video.getClientRects().length > 0;
        if (play) {
          if (video.paused) video.play().catch(() => {});
        } else {
          video.pause();
        }
      });
    }
  }

  const init = (scope) => {
    scope.querySelectorAll(selector).forEach(root => {
      if (!root.bannerVideoController) root.bannerVideoController = new BannerVideo(root);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
